import { render, staticRenderFns } from "./YaMetrika.vue?vue&type=template&id=b68a1c8c&scoped=true&"
import script from "./YaMetrika.vue?vue&type=script&lang=js&"
export * from "./YaMetrika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68a1c8c",
  null
  
)

export default component.exports